<template>
  <layout-dashboard>
    <h5 class="font-weight-bold m-0">
      Manage Master Data
    </h5>
    <small class="text-info">
      Manage Master Data
    </small>

    <div class="card mt-3">
      <div class="card-body">
        <div class="row mb-4">
          <div
            v-for="(tab, t) of tabs"
            :key="t"
            class="col-md-4 text-center"
          >
            <a
              class="tab"
              :class="{ 'active': tab.name === activeTab.name }"
              @click="setTab(tab)"
            >
              {{ tab.label }}
            </a>
          </div>
        </div>

        <div>
          <component :is="activeTab.name" />
        </div>
      </div>
    </div>
  </layout-dashboard>
</template>

<script>
import LayoutDashboard from '@/components/LayoutDashboard'
import MasterData from './ManageMasterData/MasterData'
import WorkStatus from './ManageMasterData/WorkStatus'
import WorkLocation from './ManageMasterData/WorkLocation'

export default {
  components: {
    LayoutDashboard,
    MasterData,
    WorkStatus,
    WorkLocation
  },

  data: () => ({
    activeTab: { name: 'master-data', label: 'Master Data' }
  }),

  computed: {
    tabs: () => ([
      { name: 'master-data', label: 'Master Data' },
      { name: 'work-status', label: 'Work Status' },
      { name: 'work-location', label: 'Work Location' }
    ])
  },

  methods: {
    setTab (tab) {
      this.activeTab = tab
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  border: 0;
  border-radius: 18px;
}

.tab {
  border-bottom: 3px solid #AAAAAA;
  color: inherit;
  display: block;
  padding: 10px 0;
  text-decoration: none;

  &.active {
    border-color: #18B2BD;
    color: #18B2BD;
    font-weight: bold;
  }
}
</style>
